/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";
import {ethers} from "ethers";
import truncateEthAddress from 'truncate-eth-address'
// components
import { connectWallet,getProvider } from "./WalletConnector";
import IndexDropdown from "components/Dropdowns/IndexDropdown.js";

export default function Navbar(props) {
  const [navbarOpen, setNavbarOpen] = React.useState(false);
  const [text,setText] = React.useState("Connect Wallet");
  const confirmSignIn = async () => {
    const provider = await getProvider();
    const account = await provider.listAccounts();

    if(account[0]){
      setText(truncateEthAddress(account[0]));
    }
   console.log(text)
  }
  confirmSignIn()
  return (
    <>
      <nav className="top-0 fixed z-50 w-full flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg bg-white shadow">
        <div className="container px-4 mx-auto flex flex-wrap items-center justify-between">
          <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
            <a
              href="http://www.metaflokiavatars.com"
              className="text-blueGray-700 my-Font text-2xl font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase"
            >
             Metafloki Avatars
            </a>
            <button
              className="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
              type="button"
              onClick={() => setNavbarOpen(!navbarOpen)}
            >
              <i className="fas fa-bars"></i>
            </button>
          </div>
          <div
            className={
              "lg:flex flex-grow items-center bg-white lg:bg-opacity-0 lg:shadow-none" +
              (navbarOpen ? " block" : " hidden")
            }
            id="example-navbar-warning"
          >
           
            <ul className="flex flex-col lg:flex-row list-none lg:ml-auto">
              <li className="flex items-center">
                <a href="#AboutUs">
                <span className=" text-lg font-bold my-Font inline-block ml-2">About</span>
                </a>
                 
              </li>

              <li className="flex items-center">
                <a href="#roadmap">
                <span className=" text-lg font-bold my-Font inline-block ml-2">RoadMap</span>
                </a>
                  
              </li>
             
              <li className="flex items-center">
                <a href="#Tokenomics">
                <span className=" text-lg font-bold my-Font inline-block ml-2">Tokenomics</span>
                </a>
                  
              </li>
              <li className="flex items-center">
                <a href="#Footer">
                <span className="font-bold text-lg my-Font inline-block ml-2">Contact</span>
                </a>
                 
              </li>
              <li className="flex items-center">
                <a href="#Buy">
                <span className="font-bold text-lg my-Font inline-block ml-2">How to Buy</span>
                </a>
                 
              </li>
              <li className="flex items-center">
                <button
                onClick={connectWallet}
                  className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none lg:mr-1 lg:mb-0 ml-3 mb-3 ease-linear transition-all duration-150"
                  type="button"
                >
                  <i className="fas my-Font fa-arrow-alt-circle-down"></i> {text}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
